import { TableColumn } from "react-data-table-component";
import { IConfig, IReportedMessage } from "src/services/types";

export const columnsReportsMessages: (
    config: IConfig,
    userValidatingId: string,
    showDetails: (item: IReportedMessage) => void,
) => TableColumn<IReportedMessage>[] = 
(config, userValidatingId, showDetails) => {
      
    return (
[
    { 
      name: "N°",
      width: "50px",
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
        name: "USER",
        width: "150px",
        cell: function OrderItems(item) {
            return (
                <div 
                  className="d-flex justify-content-center align-items-center gap-2 custom-avatar" 
                  style={{cursor: 'pointer'}}
                  // onClick={() => openModal(item)}
                >
                      <img
                          src={item?.user?.imagePath}
                          alt="image-user"
                          className="avatar-sm rounded-circle"
                      />
                    <div className="custom-button">
                      {item?.user?.firstName} {item?.user?.lastName}
                    </div>
                </div>
            );
        }
    },
    {
      name: "USER REPORTED",
      width: "150px",
      cell: function OrderItems(item) {
          return (
              <div 
                className="d-flex justify-content-center align-items-center gap-2 custom-avatar" 
                style={{cursor: 'pointer'}}
                // onClick={() => openModal(item)}
              >
                    <img
                        src={item?.userReported?.imagePath}
                        alt="image-user"
                        className="avatar-sm rounded-circle"
                    />
                  <div className="custom-button">
                    {item?.userReported?.firstName} {item?.userReported?.lastName}
                  </div>
              </div>
          );
      }
    },
    {
      name: "REASON",
      width: "150px",
      selector: (row: IReportedMessage) => row.reason,
    },
    {
      name: "MESSAGE",
      width: "200px",
      selector: (row: IReportedMessage) => row.message,
    },
    {
      name: "SEE DETAILS",
      width: "150px",
      cell: function OrderItems(item) {
          return (
              <button
                  type="button"
                  className="btn btn-soft-info btn-sm waves-effect waves-light"
                  onClick={() => showDetails(item)}
              >
                   <span>See details</span>
              </button>
          );
      },
    }
  ]
)}